import React, { useState, Component } from 'react';
import { motion } from 'framer-motion';
import { Tag, TrendingUp } from 'lucide-react';
export function Consignacion() {
  const [formData, setFormData] = useState({
    nombre: '',
    telefono: '',
    auto: '',
    anio: '',
    km: 'Menos de 50.000 km',
    opcion: 'Venta en consignación',
    seguro: 'Sí'
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const message = `Hola Flash & Go! Quiero dejar mi auto en consignación. Mis datos:
*Nombre:* ${formData.nombre}
*Teléfono:* ${formData.telefono}
*Auto:* ${formData.auto}
*Año:* ${formData.anio}
*Kilometraje:* ${formData.km}
*Opción:* ${formData.opcion}
*Seguro vigente:* ${formData.seguro}`;
    window.open(`https://wa.me/5491168898054?text=${encodeURIComponent(message)}`, '_blank');
  };
  return <section id="consignacion" className="py-32 bg-brand-black relative" data-id="element-112">
      <div className="max-w-7xl mx-auto px-6" data-id="element-113">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-114">
          <h2 className="font-heading text-5xl md:text-6xl text-brand-white mb-4" data-id="element-115">
            Dejanos tu auto, nosotros lo{' '}
            <span className="text-brand-gold" data-id="element-116">hacemos rendir</span>
          </h2>
          <p className="text-xl text-brand-white/80" data-id="element-117">
            Dos opciones para que tu auto trabaje por vos
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8 mb-16" data-id="element-118">
          {/* Card 1 */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-[#111] border border-brand-gold/30 p-8 rounded-xl" data-id="element-119">
            <Tag className="w-12 h-12 text-brand-gold mb-6" data-id="element-120" />
            <h3 className="font-heading text-4xl text-brand-white mb-4" data-id="element-121">
              Lo vendemos por vos
            </h3>
            <p className="text-brand-white/70 mb-8 text-lg" data-id="element-122">
              Dejás tu auto con nosotros y nos encargamos de toda la gestión de
              venta. Vos no movés un dedo.
            </p>
            <ul className="space-y-3" data-id="element-123">
              {['✓ Sin comisión anticipada', '✓ Publicación en todos los portales', '✓ Atención al comprador a cargo nuestro'].map((item, i) => <li key={i} className="text-brand-gold font-medium" data-id="element-124">
                  {item}
                </li>)}
            </ul>
          </motion.div>

          {/* Card 2 */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-[#111] border border-brand-gold/30 p-8 rounded-xl" data-id="element-125">
            <TrendingUp className="w-12 h-12 text-brand-gold mb-6" data-id="element-126" />
            <h3 className="font-heading text-4xl text-brand-white mb-4" data-id="element-127">
              Lo ponemos a trabajar
            </h3>
            <p className="text-brand-white/70 mb-6 text-lg" data-id="element-128">
              Dejamos tu auto operando en plataformas de movilidad y te
              generamos una rentabilidad mensual.
            </p>
            <div className="bg-brand-gold/10 border border-brand-gold p-4 rounded-lg mb-6 text-center" data-id="element-129">
              <span className="text-brand-gold font-bold text-xl" data-id="element-130">
                Entre $800.000 y $1.200.000 por mes
              </span>
            </div>
            <ul className="space-y-3" data-id="element-131">
              {['✓ Nosotros gestionamos todo', '✓ Pagos mensuales garantizados', '✓ Tu auto siempre asegurado'].map((item, i) => <li key={i} className="text-brand-gold font-medium" data-id="element-132">
                  {item}
                </li>)}
            </ul>
          </motion.div>
        </div>

        {/* Form */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-3xl mx-auto bg-[#111] border border-brand-gold/30 p-8 rounded-xl relative overflow-hidden" data-id="element-133">
          <div className="absolute top-0 left-0 w-full h-1 bg-brand-gold" data-id="element-134"></div>
          <h3 className="font-heading text-3xl text-brand-gold mb-6 text-center" data-id="element-135">
            Quiero dejar mi auto en consignación
          </h3>

          <form onSubmit={handleSubmit} className="space-y-4" data-id="element-136">
            <div className="grid md:grid-cols-2 gap-4" data-id="element-137">
              <div data-id="element-138">
                <label className="block text-sm text-brand-white/70 mb-1" data-id="element-139">
                  Nombre completo
                </label>
                <input required type="text" className="w-full bg-[#1a1a1a] border border-brand-white/10 rounded p-3 text-brand-white focus:border-brand-gold outline-none transition-colors" onChange={e => setFormData({
                ...formData,
                nombre: e.target.value
              })} data-id="element-140" />
              </div>
              <div data-id="element-141">
                <label className="block text-sm text-brand-white/70 mb-1" data-id="element-142">
                  Teléfono
                </label>
                <input required type="tel" className="w-full bg-[#1a1a1a] border border-brand-white/10 rounded p-3 text-brand-white focus:border-brand-gold outline-none transition-colors" onChange={e => setFormData({
                ...formData,
                telefono: e.target.value
              })} data-id="element-143" />
              </div>
            </div>

            <div className="grid md:grid-cols-3 gap-4" data-id="element-144">
              <div className="md:col-span-2" data-id="element-145">
                <label className="block text-sm text-brand-white/70 mb-1" data-id="element-146">
                  Marca y modelo del auto
                </label>
                <input required type="text" className="w-full bg-[#1a1a1a] border border-brand-white/10 rounded p-3 text-brand-white focus:border-brand-gold outline-none transition-colors" onChange={e => setFormData({
                ...formData,
                auto: e.target.value
              })} data-id="element-147" />
              </div>
              <div data-id="element-148">
                <label className="block text-sm text-brand-white/70 mb-1" data-id="element-149">
                  Año
                </label>
                <input required type="number" min="1990" max="2026" className="w-full bg-[#1a1a1a] border border-brand-white/10 rounded p-3 text-brand-white focus:border-brand-gold outline-none transition-colors" onChange={e => setFormData({
                ...formData,
                anio: e.target.value
              })} data-id="element-150" />
              </div>
            </div>

            <div data-id="element-151">
              <label className="block text-sm text-brand-white/70 mb-1" data-id="element-152">
                Kilometraje aproximado
              </label>
              <select className="w-full bg-[#1a1a1a] border border-brand-white/10 rounded p-3 text-brand-white focus:border-brand-gold outline-none transition-colors" onChange={e => setFormData({
              ...formData,
              km: e.target.value
            })} data-id="element-153">
                <option data-id="element-154">Menos de 50.000 km</option>
                <option data-id="element-155">50.000 a 100.000 km</option>
                <option data-id="element-156">100.000 a 150.000 km</option>
                <option data-id="element-157">Más de 150.000 km</option>
              </select>
            </div>

            <div className="grid md:grid-cols-2 gap-4" data-id="element-158">
              <div data-id="element-159">
                <label className="block text-sm text-brand-white/70 mb-2" data-id="element-160">
                  ¿Qué opción te interesa?
                </label>
                <div className="flex flex-col gap-2" data-id="element-161">
                  {['Venta en consignación', 'Renta mensual'].map(opt => <label key={opt} className="flex items-center gap-2 text-brand-white cursor-pointer" data-id="element-162">
                      <input type="radio" name="opcion" value={opt} className="accent-brand-gold" onChange={e => setFormData({
                    ...formData,
                    opcion: e.target.value
                  })} defaultChecked={opt === 'Venta en consignación'} data-id="element-163" />
                      {opt}
                    </label>)}
                </div>
              </div>
              <div data-id="element-164">
                <label className="block text-sm text-brand-white/70 mb-2" data-id="element-165">
                  ¿El auto tiene seguro vigente?
                </label>
                <div className="flex gap-4" data-id="element-166">
                  {['Sí', 'No'].map(opt => <label key={opt} className="flex items-center gap-2 text-brand-white cursor-pointer" data-id="element-167">
                      <input type="radio" name="seguro" value={opt} className="accent-brand-gold" onChange={e => setFormData({
                    ...formData,
                    seguro: e.target.value
                  })} defaultChecked={opt === 'Sí'} data-id="element-168" />
                      {opt}
                    </label>)}
                </div>
              </div>
            </div>

            <button type="submit" className="w-full mt-6 py-4 bg-brand-gold text-brand-black font-bold rounded hover:bg-brand-white transition-colors" data-id="element-169">
              QUIERO CONSIGNAR MI AUTO
            </button>
          </form>
        </motion.div>
      </div>

      {/* Divider */}
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-brand-gold/30 to-transparent" data-id="element-170"></div>
    </section>;
}